import { Translation } from "@jsverse/transloco";

export function flattenTranslationKeys(
  nested: Translation,
  prefix = "",
): Record<string, string> {
  const result: Record<string, string> = {};

  for (const [key, value] of Object.entries(nested)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "string") {
      result[path] = value;
    } else if (value && typeof value === "object") {
      Object.assign(result, flattenTranslationKeys(value as Translation, path));
    }
  }

  return result;
}

export function unflattenTranslationKeys(
  flat: Record<string, string>,
): Translation {
  const result: Translation = {};

  for (const [flatKey, value] of Object.entries(flat)) {
    const segments = flatKey.split(".");
    let current: Translation = result;

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];
      const isLeaf = i === segments.length - 1;

      if (isLeaf) {
        current[segment] = value;
        continue;
      }

      const next = current[segment];
      if (next == null || typeof next === "string") {
        current[segment] = {};
      }
      current = current[segment] as Translation;
    }
  }

  return result;
}
